// Static N-up compass overlay for the editor canvas.
//
// Stage axes are never rotated, so the indicator is purely decorative.
// Created and removed by editor_controller. Must be appended *after*
// Konva.Stage init because Konva wipes the container's innerHTML on
// construction (same reason createAttributionEl in satellite_layer.js
// is appended post-init rather than rendered server-side).

// Module-level counter: each compass gets fresh SVG ids so two simultaneous
// instances (e.g. controller HMR overlap, or future split-view) don't share
// gradient/filter defs.
let instanceCounter = 0

export function createCompassEl() {
  const id = ++instanceCounter
  const nGradId = `cmp-n-${id}`
  const sGradId = `cmp-s-${id}`
  const shadowId = `cmp-shadow-${id}`

  const el = document.createElement("div")
  el.className = "pointer-events-none absolute top-3 right-3 z-10 w-12 h-12 rounded-full bg-gradient-to-br from-white to-neutral-100 ring-1 ring-black/5 border border-neutral-300/70 shadow-lg flex items-center justify-center select-none"
  // No aria-hidden: orientation matters for screen-reader users too. The
  // SVG's <title> + role="img" exposes the meaning to assistive tech.
  el.innerHTML = `
    <svg viewBox="0 0 48 48" class="w-10 h-10" xmlns="http://www.w3.org/2000/svg" role="img">
      <title>Компас: север сверху</title>
      <defs>
        <linearGradient id="${nGradId}" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#ef4444"/>
          <stop offset="1" stop-color="#b91c1c"/>
        </linearGradient>
        <linearGradient id="${sGradId}" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#737373"/>
          <stop offset="1" stop-color="#404040"/>
        </linearGradient>
        <filter id="${shadowId}" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="0.4" stdDeviation="0.5" flood-opacity="0.25"/>
        </filter>
      </defs>
      <circle cx="24" cy="24" r="20.5" fill="none" stroke="#e5e5e5" stroke-width="0.6"/>
      <text x="24" y="8.5" text-anchor="middle" dominant-baseline="middle"
            font-size="6.5" font-weight="800" fill="#1f2937" letter-spacing="0.4"
            font-family="system-ui, -apple-system, 'Inter', sans-serif">N</text>
      <g filter="url(#${shadowId})">
        <path d="M 24,12 L 29.5,25 L 24,22 L 18.5,25 Z"
              fill="url(#${nGradId})" stroke="#7f1d1d" stroke-width="0.4" stroke-linejoin="round"/>
        <path d="M 24,38 L 29.5,25 L 24,28 L 18.5,25 Z"
              fill="url(#${sGradId})" stroke="#1f2937" stroke-width="0.4" stroke-linejoin="round"/>
      </g>
      <circle cx="24" cy="25" r="0.9" fill="#fafafa" stroke="#525252" stroke-width="0.3"/>
    </svg>
  `
  return el
}
